<template>
  <div :class="dirty ? (valid ? 'success-hint' : 'error-hint') : ''">
    <v-icon
      size="12"
      :color="dirty ? (valid ? 'success' : 'error') : 'default'"
      :icon="valid ? mdiCheckCircle : mdiCloseCircle"
    />
    <span>
      <slot />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mdiCheckCircle, mdiCloseCircle } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'PasswordHint',
  props: {
    dirty: {
      type: Boolean,
      required: true,
      default: false,
    },
    valid: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    mdiCheckCircle,
    mdiCloseCircle,
  }),
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
:deep(.v-icon) {
  padding-bottom: 2px;
}
</style>
